import { ContactForm } from '@/components/common/ContactForm';
import { MotionReveal } from '@/components/common/MotionReveal';
import { PageHero } from '@/components/common/PageHero';
import { Seo } from '@/components/common/Seo';
import { ContactInfo } from '@/components/contact/ContactInfo';
import { MapSection } from '@/components/contact/MapSection';
import { PrivacyNotice } from '@/components/contact/PrivacyNotice';
import { SocialLinks } from '@/components/contact/SocialLinks';

export default function Contact() {
  return (
    <>
      <Seo
        title="Kontakt"
        description="Kontaktirajte Helmflex za pitanje, savet ili ponudu. Pošaljite poruku putem forme ili koristite istaknute kontakt podatke."
      />
      <PageHero
        eyebrow="Helmflex / Kontakt"
        title="Kontaktirajte nas"
        description="Pošaljite osnovne informacije o projektu. Javićemo se da proverimo obim, rok i odgovarajući format saradnje."
      />

      <section className="py-18 sm:py-24 lg:py-30">
        <div className="site-container grid gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:items-start lg:gap-14">
          <MotionReveal>
            <div className="mb-7">
              <p className="section-label">Pošaljite upit</p>
              <h2 className="mt-3 text-2xl font-semibold tracking-[-0.03em] text-text-primary sm:text-3xl">Recite nam kako možemo da pomognemo.</h2>
            </div>
            <ContactForm variant="full" />
          </MotionReveal>

          <MotionReveal delay={0.08} className="lg:sticky lg:top-28">
            <div className="mb-7">
              <p className="section-label">Direktan kontakt</p>
              <h2 className="mt-3 text-2xl font-semibold tracking-[-0.03em] text-text-primary sm:text-3xl">Izaberite način koji vam odgovara.</h2>
            </div>
            <ContactInfo />
            <div className="mt-8">
              <SocialLinks />
            </div>
          </MotionReveal>
        </div>
      </section>

      <PrivacyNotice />
      <MapSection />
    </>
  );
}
